"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isPositiveDependencies = void 0;

var _dependenciesTypedGenerated = require("./dependenciesTyped.generated.js");

var _factoriesAny = require("../../factoriesAny.js");

/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
var isPositiveDependencies = {
  typedDependencies: _dependenciesTypedGenerated.typedDependencies,
  createIsPositive: _factoriesAny.createIsPositive
};
exports.isPositiveDependencies = isPositiveDependencies;